export class RegexConstants {
  public static EMAIL =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}])|(([a-zA-Z\-\d]+\.)+[a-zA-Z]{2,}))$/;
  public static PASSWORD = /^(?=.*[A-Z])(?=.*\d)\S{8,}$/;
  public static SITE_NAME = /^[\w\s\-+_().]*$/;
}
